import { ReactNode } from "react";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { 
  SidebarProvider, 
  Sidebar as UISidebar,
  SidebarContent,
  SidebarInset
} from "@/components/ui/sidebar";
import { useBreakpoint } from "@/providers/BreakpointProvider";

interface LayoutProps {
  children: ReactNode;
  onCreateCard: () => void;
}

export function Layout({ children, onCreateCard }: LayoutProps) {
  const { isMobile } = useBreakpoint();

  return (
    <SidebarProvider defaultOpen={!isMobile}>
      <div id="layout" className="w-full flex bg-background">
        <UISidebar variant="sidebar">
          <SidebarContent>
            <Sidebar onCreateCard={onCreateCard} />
          </SidebarContent>
        </UISidebar>
        <SidebarInset className="w-full flex flex-col">
          <Header onCreateCard={onCreateCard} />
          <main className="flex-1 w-full">
              {children}
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
} 